export function GridDetailPanels(_) {
    return null;
}
